import React, { useState } from "react";

import Header from "../../../component/header";
import { Container, Card, Button, Form, Alert } from "tabler-react";
import { SERVER_URL } from "../../../utils/server.constant";
import axios from "axios";
import { ROUTES } from "../../../route";
import { useHistory } from "react-router-dom";

const CreateUser = (props) => {
  const history = useHistory();
  const [state, setState] = React.useState({
    name: "",
    mobile: "",
    email: "",
    memberID: "",
    transactionID: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const handleChange = (evt) => {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  };
  const _onaddnewUser = async (e) => {
    e.preventDefault();
    const token = await localStorage.getItem("token");
    setError("");
    setSuccess("");
    if (state.name === "") {
      setError("Customer name is required");
    } else if (state.mobile === "") {
      setError("Mobile Number is required");
    } else if (state.memberID === "") {
      setError("Member ID is required");
    } else if (state.transactionID === "") {
      setError("Transaction ID is required");
    } else {
      await axios
        .post(
          `${SERVER_URL}/user/`,
          {
            name: state.name,
            mobile: state.mobile,
            email:state.email,
            memberID: state.memberID,
            transactionID: state.transactionID,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(async (res) => {

          await history.push({
            
            pathname: ROUTES.DASHBOARD,
            state: {

              success: "Add"
            }
          });
        })
        .catch((e) => {
         setError("Duplicate User");
        });
    }
  };
  return (
    <>
      <Header >
      <div className="my-3 my-md-5">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title> Create New User</Card.Title>
            </Card.Header>
            {success && <Alert type="success">{success}</Alert>}
            {error && <Alert type="danger">{error}</Alert>}
            <Card.Body>
              <Form>
                <Form.Group>
                  <Form.Label>Customer Name</Form.Label>
                  <Form.Input
                    value={state.name}
                    onChange={handleChange}
                    name="name"
                    placeholder="Enter Customer Name"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Input
                    value={state.mobile}
                    onChange={handleChange}
                    name="mobile"
                    type="number"
                    placeholder="Enter Mobile Number"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Input
                    value={state.email}
                    onChange={handleChange}
                    name="email"
                    type="email"
                    placeholder="Enter  Email Address"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Member Id</Form.Label>
                  <Form.Input
                    value={state.memberID}
                    onChange={handleChange}
                    name="memberID"
                    placeholder="Enter Member Id"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label> Transaction Id</Form.Label>
                  <Form.Input
                    value={state.transactionID}
                    onChange={handleChange}
                    name="transactionID"
                    placeholder="Enter Transaction Id"
                  />
                </Form.Group>

                <Form.Footer>
                  <Button onClick={_onaddnewUser} color="primary" block>
                    Submit
                  </Button>
                </Form.Footer>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      </div>
      </Header>
    </>
  );
};
export default CreateUser;
